<template>
	<div class='tw-flex tw--mx-20'>
    	<div class="px-3 tw-w-2/3">
			<process-model-stepper :current-step="1">
			</process-model-stepper>
			<div class="form-page mt-3">
				<form>
					<v-layout row>
						<v-flex xs6 tw-pr-1>
							<label :style="`color:${$appColors.info}`">
								Nombre de la Evaluación
								<input
									class="form-process-input"
									placeholder="Nombre"
									v-model="nameProcess"
									@blur="$v.nameProcess.$touch()"
								/>
								<span
									class="form-group__message"
									v-if="$v.nameProcess.$error && !$v.nameProcess.required"
									:style="`color:${$appColors.error}`">
									El nombre es obligatorio
								</span>
								<span
									class="form-group__message"
									v-if="$v.nameProcess.$error && !$v.nameProcess.minLength"
									:style="`color:${$appColors.error}`">
									El nombre debe tener al menos 3 caracteres
								</span>
								<span
									class="form-group__message"
									v-if="$v.nameProcess.$error && !$v.nameProcess.maxLength"
									:style="`color:${$appColors.error}`">
									El nombre no puede exceder 200 caracteres
								</span>
							</label>
						</v-flex>
						<v-flex xs6 tw-pl-1 tw-pt-1>
							<label :style="`color:${$appColors.info}`">
								Evaluación
								<v-select
									label="Evaluación"
									class="select-core"
									hide-details
									:menu-props="{ contentClass: 'type-select-content' }"
									height="37"
									outline
									single-line
									:items="polls"
									item-value="id"
									item-text="name"
									v-model="evaluationType"
									return-object
									@input="getEvaluation($event)"
								></v-select>
								<span
									class="form-group__message"
									v-if="!$v.evaluationType.required"
									:style="`color:${$appColors.error}`">
									La evaluación es obligatoria.
								</span>
							</label>
						</v-flex>

					</v-layout>
					<v-layout row tw-mt-3>
						<v-flex xs8>
							<label :style="`color:${$appColors.info}`">
								Área
								<v-select
									label="Escoge Puesto"
									class="select-core"
									hide-details
									:menu-props="{ contentClass: 'type-select-content' }"
									height="37"
									outline
									multiple
									chips
									single-line
									:items="groups"
									item-value="id"
									item-text="name"
									v-model="group"
									return-object
									@input="getGroup($event)"
								/>
								<span
									class="form-group__message" v-if="!$v.group.required"
									:style="`color:${$appColors.error}`">
									El área es obligatoria
								</span>
							</label>
						</v-flex>
						<v-flex v-if="idEditProcess" xs2 tw-px-1>
							<label class="" :style="`color:${$appColors.info}`">
								Fecha Inicio
								<app-date-flat
									v-if="startDate && endDate"
									v-model="startDate"
									:default-date="startDate"
									:style="`border-radius:4px;color: ${$appColors.info} !important`"
									@input="setDate({ model: 'startDate', value: $event })"
								/>
								<span
									class="form-group__message"
									v-if="!$v.startDate.required"
									:style="`color:${$appColors.error}`">
									La Fecha es obligatoria.
								</span>
							</label>
						</v-flex>
						<v-flex v-else xs2 tw-px-1>
							<label class="" :style="`color:${$appColors.info}`">
								Fecha Inicio
								<app-date-flat
									v-model="startDate"
									:default-date="startDate"
									:style="`border-radius:4px;color: ${$appColors.info} !important`"
									@input="setDate({ model: 'startDate', value: $event })"
								/>
								<span
									class="form-group__message"
									v-if="!$v.startDate.required"
									:style="`color:${$appColors.error}`">
									La Fecha es obligatoria.
								</span>
							</label>
						</v-flex>
						<v-flex v-if="idEditProcess" xs2 tw-pl-1>
							<label class="" :style="`color:${$appColors.info}`">
								Fecha Fin
								<app-date-flat
									v-if="startDate && endDate"
									v-model="endDate"
									:default-date="endDate"
									:style="`border-radius:4px;color: ${$appColors.info} !important`"
									@input="setDate({ model: 'endDate', value: $event })"
								/>
								<span
									class="form-group__message"
									v-if="!$v.endDate.required"
									:style="`color:${$appColors.error}`">
									La Fecha es obligatoria.
								</span>
							</label>
						</v-flex>
						<v-flex v-else xs2 tw-pl-1>
							<label class="" :style="`color:${$appColors.info}`">
								Fecha Fin
								<app-date-flat
									v-model="endDate"
									:default-date="endDate"
									:style="`border-radius:4px;color: ${$appColors.info} !important`"
									@input="setDate({ model: 'endDate', value: $event })"
								/>
								<span
									class="form-group__message"
									v-if="!$v.endDate.required"
									:style="`color:${$appColors.error}`">
									La Fecha es obligatoria.
								</span>
							</label>
						</v-flex>
					</v-layout>
					<v-layout row tw-mt-3>
						<v-flex xs12>
							<label :style="`color:${$appColors.info}`">
								Grupos de Referencia
								<v-select
									label="Grupo de Referencia"
									class="select-core"
									hide-details
									multiple
									chips
									autocomplete
									clearable
									height="17"
									outline
									single-line
									:items="referenceGroups"
									item-value="id"
									item-text="name"
									v-model="referenceGroup"
									return-object
								>
									<template slot="selection" slot-scope="data">
										<v-chip
											class="tag-chip"
											close
											@input="removeItem(data.item)">
											{{ data.item.name }}
										</v-chip>
									</template>
								</v-select>
								<span
									class="form-group__message"
									v-if="!$v.referenceGroup.required"
									:style="`color:${$appColors.error}`">
									Seleccione al menos un grupo de referencia
								</span>
							</label>
						</v-flex>
					</v-layout>
					<v-layout row tw-mt-3>
						<v-flex xs6 tw-pr-1>
						<label :style="`color:${$appColors.info}`">
							Metodología
							<textarea
								class="form-process-input"
								placeholder="Metodología"
								v-model="methodology"
								@blur="$v.methodology.$touch()"/>
							<span
								class="form-group__message"
								v-if="$v.methodology.$error && !$v.methodology.required"
								:style="`color:${$appColors.error}`">
								Introduzca la metodología del Proceso
							</span>
							<span
								class="form-group__message"
								v-if="$v.methodology.$error && !$v.methodology.minLength"
								:style="`color:${$appColors.error}`">
								La metodología debe tener al menos 10 caracteres
							</span>
							<span
								class="form-group__message"
								v-if="$v.methodology.$error && !$v.methodology.maxLength"
								:style="`color:${$appColors.error}`">
								La metodología no puede exceder 5000 caracteres
							</span>
						</label>
						</v-flex>
						<v-flex xs6 tw-pl-1>
						<label :style="`color:${$appColors.info}`">
							Introducción
							<textarea
								class="form-process-input"
								placeholder="Introducción"
								v-model="introduction"
								@blur="$v.introduction.$touch()"/>
							<span
								class="form-group__message"
								v-if="$v.introduction.$error && !$v.introduction.required"
								:style="`color:${$appColors.error}`">
								Introduzca la Introducción del Proceso
							</span>
							<span
								class="form-group__message"
								v-if="$v.introduction.$error && !$v.introduction.minLength"
								:style="`color:${$appColors.error}`">
								La introducción debe tener al menos 10 caracteres
							</span>
							<span
								class="form-group__message"
								v-if="$v.introduction.$error && !$v.introduction.maxLength"
								:style="`color:${$appColors.error}`">
								La introducción no puede exceder 5000 caracteres
							</span>
						</label>
						</v-flex>
					</v-layout>
				</form>
			</div>
			<div class="nqt-container my-3">
				<h2
					class="nqt-container-title"
					:style="`border-bottom:1px solid ${$appColors.gray};color:${$appColors.info}`"
				>Escala de Evaluación</h2>
				<div class="nqt-body">
						<table>
							<tbody :style="`color:${$appColors.info}`">
								<template v-if="evaluationScalesEdit.length === 0">
									<tr
										class="striped-row" :class="'row-' + index"
										v-for="evaluationScale, index in evaluationScales" :key="index">
										<td class="tw-px-1 tw-pl-12"
											style="width: 17%; font-weight: bold; font-size: 16px; text-align: left;"
											:style=" { color: evaluationScale.color }">
											{{ evaluationScale.name }}
										</td>
										<td class="tw-px-0" style="width: 20%;">
											({{ minValue }}- {{ maxValue }}  con 2 decimales)
										</td>
										<td class="tw-px-1" style="width: 7%;">
											<v-text-field class="input-scale tw-px-1" type="number"
												@input="updateScales({ value: $event, index, tag: 'min'})">
											</v-text-field>
										</td>
										<td class="tw-px-1" style="width: 7%;">
											<v-text-field class="input-scale tw-px-1" type="number"
												@input="updateScales({ value: $event, index, tag: 'max'})">
											</v-text-field>
										</td>
										<td style="width: 56%;">
											<p v-if="evaluationScales[index].error" class="error-message">{{ evaluationScales[index].errorMessage }}</p>
										</td>
									</tr>
								</template>
								<template v-if="evaluationScalesEdit.length > 0">
									<tr 
										class="striped-row" :class="'row-' + index" 
										v-for="evaluationScale, index in evaluationScalesEdit" :key="index">
										<td class="tw-px-1 tw-pl-12"
											style="width: 17%; font-weight: bold; font-size: 16px; text-align: left;"
											:style=" { color: evaluationScale.color }">
											{{ evaluationScale.name }}
										</td>
										<td class="tw-px-0" style="width: 20%;">
											({{ minValue }}- {{ maxValue }}  con 2 decimales)
										</td>
										<td class="tw-px-1" style="width: 7%;">
											<v-text-field class="input-scale tw-px-1" type="number"
												id="value-min"
												:value="evaluationScale.scale.min"
												@input="updateScales({ value: $event, index, tag: 'min'})">
											</v-text-field>
										</td>
										<td class="tw-px-1" style="width: 7%;">
											<v-text-field class="input-scale tw-px-1" type="number"
												:value="evaluationScale.scale.max"
												@input="updateScales({ value: $event, index, tag: 'max'})">
											</v-text-field>
										</td>
										<td class="error-cell" style="width: 56%;">
										<p v-if="evaluationScalesEdit[index].error" class="error-message">{{ evaluationScalesEdit[index].errorMessage }}</p>
										</td>
									</tr>
								</template>
							</tbody>
						</table>
				</div>
				<div class="nqt-btn"
					:style="`border-top:1px solid ${$appColors.gray};`"
				>
					<v-btn
						color="primary"
						class="btn-action"
						@click="goTo('list-process')"
					>
						Atrás
					</v-btn>
					<v-btn
						:disabled="(!isFormValid || checkArray)"
						color="primary"
						class="btn-action"
						@click="nextStep"
					>
						Siguiente
					</v-btn>
				</div>
			</div>
    	</div>
		<div class="tw-w-1/3 px-3">
			<process-model-description>
			</process-model-description>
		</div>
	</div>
</template>

<script>
import processModelStepper from '@/modules/evaluation-360/components/process/process-model-stepper';
import processModelDescription from '@/modules/evaluation-360/components/process/process-model-description';
import dateComponent from '@/components/shared/date-component/date-component';
import appDateMask from '@/components/app-date-mask';
// import appDate from '@/components/shared/app-date';
import appDateHour from '@/components/shared/app-date-hour';
import appDateFlat from '@/components/shared/app-date-flat';
import selectOption from '@/components/shared/selected-option';
import { required, maxLength, minLength } from 'vuelidate/lib/validators';
import { differenceInDays, format } from 'date-fns';
import helper from '@/shared/helper';
import { mapState } from 'vuex';
import { pathOr } from 'ramda';

const { getLocalData } = helper;

async function created() {
	this.idEditProcess = this.$route.params.id;
	this.updateEvaluationScale = this.evaluationScales;
	await this.loadData();
	if (this.idEditProcess) {
		this.loadProcess(this.idEditProcess);
	}
}

function mounted() {
	if (this.idEditProcess) {
		this.loadProcess(this.idEditProcess);
	}
	if (!this.idEditProcess && this.process) {
		const {
			name,
			groups,
			pollId,
			referenceGroups,
			startDate,
			endDate,
			evaluationScale,
			methodology,
			introduction,
		} = this.process;
		this.nameProcess = name;
		this.group = groups.areas;
		this.evaluationType = pollId;
		if (this.evaluationType) {
			this.evaluationSelect = this.polls.find(p => p.id === this.evaluationType);
		}
		this.referenceGroup = referenceGroups.references;
		this.startDate = format(startDate, 'YYYY-MM-DD HH:mm');
		this.endDate = format(endDate, 'YYYY-MM-DD HH:mm');
		this.methodology = methodology;
		this.introduction = introduction;
		this.evaluationScalesEdit = evaluationScale.scale;
		if (this.evaluationScalesEdit.length > 0) {
			this.evaluationScalesEdit.forEach((value, index) => {
				this.$set(this.updateEvaluationScale, index, { ...value });
				this.updateScales({ value: value.scale.min, index, tag: 'min' });
				this.updateScales({ value: value.scale.max, index, tag: 'max' });
			});
		}
	}
}

async function loadProcess(id) {
	try {
		const { data: response } = await this.$httpPraktiko.get(`process/detail/${id}`);
		const {
			name,
			groups,
			pollId,
			referenceGroups,
			startDate,
			endDate,
			evaluationScale,
			methodology,
			introduction,
		} = response;
		this.nameProcess = name;
		this.group = groups.areas;
		this.evaluationType = pollId;
		this.referenceGroup = referenceGroups.references;
		this.startDate = format(startDate, 'YYYY-MM-DD HH:mm');
		this.endDate = format(endDate, 'YYYY-MM-DD HH:mm');
		this.methodology = methodology;
		this.introduction = introduction;
		this.evaluationScalesEdit = evaluationScale.scale;
		if (this.evaluationScalesEdit.length > 0) {
			this.evaluationScalesEdit.forEach((value, index) => {
				this.$set(this.updateEvaluationScale, index, { ...value });
				this.updateScales({ value: value.scale.min, index, tag: 'min' });
				this.updateScales({ value: value.scale.max, index, tag: 'max' });
			});
		}
		this.$store.dispatch('evaluation360/assignProcess', response);
	} catch (error) {
		this.showGenericError(error);
	}
}

function updateScalesAtIndex({ value, index, tag }) {
	const scale = this.updateEvaluationScale[index].scale;
	const typeAction = this.idEditProcess ? this.evaluationScalesEdit : this.evaluationScales;

	// Configuración de validaciones por índice
	const validationConfig = {
		0: { // Alto
			max: {
				upperLimit: this.maxValue,
				lowerBoundary: () => (this.updateEvaluationScale[1] &&
					this.updateEvaluationScale[1].scale ? this.updateEvaluationScale[1].scale.max : 0),
				messages: {
					upperLimit: `El valor no debe ser mayor que ${this.maxValue}`,
					empty: 'El valor no puede quedar vacío',
					lowerBoundary: 'El máximo de \'Alto\' no puede ser menor o igual al mínimo de \'Alto\'',
				},
			},
			min: {
				upperBoundary: () => (this.updateEvaluationScale[1] &&
					this.updateEvaluationScale[1].scale ? this.updateEvaluationScale[1].scale.max : 0),
				messages: {
					upperBoundary: 'El mínimo de \'Alto\' no puede ser menor que el máximo de \'Medio Alto\'',
					empty: 'El valor no puede quedar vacío',
					selfMax: 'El mínimo de \'Alto\' no puede ser mayor o igual al máximo de \'Alto\'',
				},
			},
		},
		1: { // Medio Alto
			max: {
				upperBoundary: () => (this.updateEvaluationScale[0] &&
					this.updateEvaluationScale[0].scale ?
					this.updateEvaluationScale[0].scale.min : this.maxValue),
				messages: {
					upperBoundary: 'El máximo de \'Medio Alto\' no puede ser mayor o igual al mínimo de \'Alto\'',
					empty: 'El valor no puede quedar vacío',
					lowerBoundary: 'El máximo de \'Medio Alto\' no puede ser menor o igual al mínimo de \'Medio Alto\'',
				},
			},
			min: {
				lowerBoundary: () => (this.updateEvaluationScale[2] &&
					this.updateEvaluationScale[2].scale ? this.updateEvaluationScale[2].scale.max : 0),
				messages: {
					lowerBoundary: 'El mínimo de \'Medio Alto\' no puede ser menor o igual al máximo de \'Medio\'',
					empty: 'El valor no puede quedar vacío',
					selfMax: 'El mínimo de \'Medio Alto\' no puede ser mayor o igual al máximo de \'Medio Alto\'',
				},
			},
		},
		2: { // Medio
			max: {
				upperBoundary: () => (this.updateEvaluationScale[1] &&
					this.updateEvaluationScale[1].scale ?
					this.updateEvaluationScale[1].scale.min : this.maxValue),
				messages: {
					upperBoundary: 'El máximo de \'Medio\' no puede ser mayor o igual al mínimo de \'Medio Alto\'',
					empty: 'El valor no puede quedar vacío',
					lowerBoundary: 'El máximo de \'Medio\' no puede ser menor o igual al mínimo de \'Medio\'',
				},
			},
			min: {
				lowerBoundary: () => (this.updateEvaluationScale[3] &&
					this.updateEvaluationScale[3].scale ? this.updateEvaluationScale[3].scale.max : 0),
				messages: {
					lowerBoundary: 'El mínimo de \'Medio\' no puede ser menor o igual al máximo de \'Bajo\'',
					empty: 'El valor no puede quedar vacío',
					selfMax: 'El mínimo de \'Medio\' no puede ser mayor o igual al máximo de \'Medio\'',
				},
			},
		},
		3: { // Bajo
			max: {
				upperBoundary: () => (this.updateEvaluationScale[2] &&
					this.updateEvaluationScale[2].scale ?
					this.updateEvaluationScale[2].scale.min : this.maxValue),
				messages: {
					upperBoundary: 'El máximo de \'Bajo\' no puede ser mayor o igual al mínimo de \'Medio\'',
					empty: 'El valor no puede quedar vacío',
					lowerBoundary: 'El máximo de \'Bajo\' no puede ser menor o igual al mínimo de \'Bajo\'',
				},
			},
			min: {
				lowerLimit: this.minValue,
				messages: {
					lowerLimit: `El valor mínimo permitido debe ser ${this.minValue}`,
					empty: 'El valor no puede quedar vacío',
					selfMax: 'El mínimo de \'Bajo\' no puede ser mayor o igual al máximo de \'Bajo\'',
				},
			},
		},
	};

	// Función para validar y establecer error
	const setError = (hasError, message = '') => {
		this.$set(this.flagMaxMin, index, hasError);
		this.$set(typeAction[index], 'error', hasError);
		this.$set(typeAction[index], 'errorMessage', message);
		if (message && index === 2 && tag === 'min' && value === '') {
			this.showNotification(message);
		}
	};

	const validateField = (inputValue, inputTag, config) => {
		const tagConfig = config[inputTag];
		if (!tagConfig) return { hasError: false };
		if (inputValue === '') return { hasError: true, errorMessage: tagConfig.messages.empty };
		let hasError = false;
		let errorMessage = '';
		if (inputTag === 'max') {
			if (tagConfig.upperLimit !== undefined && Number(inputValue) > Number(tagConfig.upperLimit)) {
				hasError = true; errorMessage = tagConfig.messages.upperLimit;
			} else if (
				tagConfig.upperBoundary &&
				Number(inputValue) >= Number(tagConfig.upperBoundary())
			) {
				if (tag === 'max') { hasError = true; errorMessage = tagConfig.messages.upperBoundary; }
			} else if (Number(inputValue) <= Number(scale.min)) {
				hasError = true; errorMessage = tagConfig.messages.lowerBoundary;
			}
		} else if (inputTag === 'min') {
			if (tagConfig.lowerLimit !== undefined && Number(inputValue) < Number(tagConfig.lowerLimit)) {
				hasError = true; errorMessage = tagConfig.messages.lowerLimit;
			} else if (
				tagConfig.lowerBoundary &&
				Number(inputValue) <= Number(tagConfig.lowerBoundary())
			) {
				if (tag === 'min') { hasError = true; errorMessage = tagConfig.messages.lowerBoundary; }
			} else if (
				tagConfig.upperBoundary &&
				Number(inputValue) >= Number(tagConfig.upperBoundary())
			) {
				if (tag === 'min') { hasError = true; errorMessage = tagConfig.messages.upperBoundary; }
			} else if (Number(inputValue) >= Number(scale.max)) {
				hasError = true; errorMessage = tagConfig.messages.selfMax;
			}
		}
		return { hasError, errorMessage };
	};
	// Update the value in the scale object before validation
	scale[tag] = value;
	const config = validationConfig[index];
	if (config) {
		const minResult = validateField(scale.min, 'min', config);
		const maxResult = validateField(scale.max, 'max', config);
		const finalError = minResult.hasError || maxResult.hasError;
		let finalMessage = '';
		// Prioritize showing the error for the field being edited
		if (tag === 'min' && minResult.hasError) {
			finalMessage = minResult.errorMessage;
		} else if (tag === 'max' && maxResult.hasError) {
			finalMessage = maxResult.errorMessage;
		} else if (minResult.hasError) {
			finalMessage = minResult.errorMessage;
		} else if (maxResult.hasError) {
			finalMessage = maxResult.errorMessage;
		}
		setError(finalError, finalMessage);
	}
}

function updateScalesForAllIndex() {
	for (let i = 0; i < this.updateEvaluationScale.length; i += 1) {
		const scale = this.updateEvaluationScale[i].scale;
		this.updateScalesAtIndex({
			value: scale.min,
			index: i,
			tag: 'min',
		});
		this.updateScalesAtIndex({
			value: scale.max,
			index: i,
			tag: 'max',
		});
	}
}

function updateScales({ value, index, tag }) {
	this.updateScalesAtIndex({ value, index, tag });
	this.updateScalesForAllIndex();
}

function checkArray() {
	const lengthUpdate = this.updateEvaluationScale.length;
	if (this.flagMaxMin.length === 4 && this.updateEvaluationScale[lengthUpdate - 1].scale.max !== ('' || null)) {
		return (this.flagMaxMin.includes(true));
	}
	return true;
}

function isFormValid() {
	const datesValid = differenceInDays(this.startDate, this.endDate) <= 0;
	return (
		this.$v.nameProcess.required &&
        this.$v.group.required &&
        this.$v.evaluationType.required &&
        this.$v.referenceGroup.required &&
        this.$v.startDate.required &&
        this.$v.endDate.required && datesValid &&
		this.$v.methodology.required &&
		this.$v.introduction.required);
}

function setDate({ model, value }) {
	this[model] = format(value, 'YYYY-MM-DD HH:mm');
	if (this.startDate && this.endDate) {
		const datesValid = differenceInDays(this.startDate, this.endDate) > 0;
		if (datesValid) {
			this.showGenericError('La fecha inicial no debe superar a la fecha final.');
		}
	}
}

function clearDate(model) {
	this[model] = null;
}


async function listPolls() {
	try {
		const response = await this.$http.get('poll-employees/process');
		this.polls = response.data.filter(f => Object.keys(f.poll).length > 0).map((r) => {
			const newR = {
				id: r.poll.id,
				name: r.poll.name,
			};
			return newR;
		});
	} catch (error) {
		this.showGenericError();
	}
}

async function loadData() {
	const requests = [
		this.$httpPraktiko.get('groups'),
		this.$httpPraktiko.get('groups/jobs?typeGroup=2'),
		this.$http.get('polls?toolCode=E360&state=1'),
	];
	try {
		[{ data: this.groups }, { data: this.jobs }, { data: this.polls }]
			= await Promise.all(requests);
		this.groups = this.groups.map((g) => {
			const newGroup = { ...g };
			newGroup.isSelected = false;
			return newGroup;
		});
		if (this.evaluationType) {
			const foundEvaluation = this.polls.find(p => p.id === this.evaluationType);
			this.evaluationSelect = foundEvaluation;
			const sortAnswers =
				this.evaluationSelect.answer.details.sort((a, b) => b.value - a.value);
			this.maxValue = sortAnswers[0].value;
			this.minValue = sortAnswers[sortAnswers.length - 1].value;
			this.factorW = foundEvaluation.factorsWeight;
			this.factorW = this.factorW.map(f => f.jobId)
				.filter((valueFW, index, self) => self.indexOf(valueFW) === index);
		}
		this.jobs = this.jobs.filter(job => this.factorW.includes(job.id));
		const areaIds = this.jobs.map(r => r.areaId)
			.filter((valueAI, index, self) => self.indexOf(valueAI) === index);
		this.groups = this.groups.filter(group => areaIds.includes(group.id));
	} catch (error) {
		this.showGenericError();
	}
}

function removeItem(item) {
	const index = this.referenceGroup.indexOf(item.id);
	if (index > -1) {
		this.referenceGroup.splice(index, 1);
	}
}

function getGroup(value) {
	this.group = value;
}

function getEvaluation(value) {
	this.factorW = value.factorsWeight;
	this.factorW = this.factorW.map(f => f.jobId)
		.filter((valueFW, index, self) => self.indexOf(valueFW) === index);
	this.evaluationType = value.id;
	this.loadData();
}

function getReferenceGroup({ model, value }) {
	this[model] = value;
}

async function nextStep() {
	try {
		const groupsSelect = this.group.map((group) => {
			const newGroup = {
				id: group.id,
				name: group.name,
				companyId: group.companyId,
			};
			return newGroup;
		});
		const body = {
			name: this.nameProcess,
			pollId: this.evaluationType,
			startDate: this.startDate,
			endDate: this.endDate,
			methodology: this.methodology,
			introduction: this.introduction,
			toolId: this.idTool,
			toolCode: this.codeTool,
			groups: {
				areas: groupsSelect,
			},
			referenceGroups: {
				references: this.referenceGroup,
			},
			evaluationScale: {
				scale: this.updateEvaluationScale,
			},
		};
		if (this.process && !this.idEditProcess) {
			this.goTo('process-choose-employees');
			await this.$httpPraktiko.patch(`process/${this.process.id}`, body);
			this.loadProcess(this.process.id);
		} else if (this.idEditProcess) {
			await this.$httpPraktiko.patch(`process/${this.idEditProcess}`, body);
			this.loadProcess(this.idEditProcess);
			this.$store.dispatch('evaluation360/saveJobIds', this.factorW);
			this.showNotification('Proceso editado Exitosamente');
			this.goTo('edit-choose-employees');
		} else {
			const { data: processSend } = await this.$httpPraktiko.post('process', body);
			this.$store.dispatch('evaluation360/assignProcess', processSend);
			this.$store.dispatch('evaluation360/saveJobIds', this.factorW);
			this.goTo('process-choose-employees');
			this.showNotification('Proceso creado Exitosamente');
		}
	} catch (error) {
		this.showGenericError('Complete todos los campos requeridos');
	}
}

function beforeMount() {
	if (!this.referenceGroups || this.referenceGroups.length === 0) {
		this.$store.dispatch('evaluation360/loadEvaluation360');
	}
}

function validations() {
	return {
		nameProcess: {
			required,
			minLength: minLength(3),
			maxLength: maxLength(200),
		},
		group: { required },
		evaluationType: { required },
		referenceGroup: { required },
		startDate: { required },
		endDate: { required },
		methodology: {
			required,
			minLength: minLength(10),
			maxLength: maxLength(5000),
		},
		introduction: {
			required,
			minLength: minLength(10),
			maxLength: maxLength(5000),
		},
	};
}

function data() {
	return {
		updateEvaluationScale: [],
		nameProcess: '',
		groups: [],
		group: '',
		evaluationType: '',
		factorW: [],
		referenceGroup: [],
		startDate: null,
		endDate: null,
		methodology: '',
		introduction: '',
		state: 1,
		polls: [],
		jobs: [],
		flagMaxMin: [],
		idEditProcess: null,
		evaluationScalesEdit: [],
		evaluationSelect: null,
		maxValue: 3,
		minValue: 0,
	};
}

export default {
	name: 'page-configuration-process',
	data,
	created,
	mounted,
	beforeMount,
	components: {
		processModelStepper,
		processModelDescription,
		dateComponent,
		appDateMask,
		appDateFlat,
		appDateHour,
		selectOption,
	},
	computed: {
		checkArray,
		isFormValid,
		// termination,
		...mapState('evaluation360', {
			evaluationScales:
				pathOr([], ['mainData', 'config', 'evaluationScale']),
			evaluationTypes:
				pathOr([], ['mainData', 'config', 'evaluationTypes']),
			referenceGroups:
				pathOr([], ['mainData', 'config', 'referenceGroups']),
			idTool:
				pathOr([], ['mainData', 'id']),
			codeTool:
				pathOr([], ['mainData', 'code']),
			process:
				pathOr(null, ['process']) || getLocalData(process),
		}),
	},
	methods: {
		loadData,
		loadProcess,
		listPolls,
		updateScales,
		updateScalesAtIndex,
		updateScalesForAllIndex,
		removeItem,
		setDate,
		clearDate,
		getGroup,
		getEvaluation,
		getReferenceGroup,
		nextStep,
	},
	validations,
};

</script>

<style lang="scss" scoped>
.form-page {
	display: flex;
	justify-content: center;
	width: 100%;
	border: 1px solid #E9E9E9;
	background-color: map-get($colors, white);
	padding: 25px;
	border-radius: 8px;
    form {
        width: 100%;
    }
}

.form-process {
	bottom: 0;
	left: 0;
	padding: 0;
	position: relative !important;
	right: 0;

	&-input {
		background: map-get($colors, white);
		border: 1px solid map-get($colors, gray-slider);
		border-radius: 4px;
        display: block;
        outline: none;
		color: map-get($colors, secondary);
		margin-top: 4px;
		padding: 10px 20px;
		width: 100%;

		&::placeholder {
			color: map-get($colors, placeholder);
		}
	}
}
.nqt-container {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	width: 100%;
	border: 1px solid #E9E9E9;
	background-color: map-get($colors, white);
	border-radius: 8px;

	.nqt-container-title {
		font-size: size(xlarge);
		padding: 20px 30px;
	}
	.nqt-body {
		width: 100%;
		height: auto;
	}
	.nqt-btn {
		align-items: center;
		display: flex;
		justify-content: center;
		gap: 10px;
		padding: 20px 30px;
	}

}
table {
	border-collapse: collapse;
	width: 100%;
	td {
		align-items: center;
		justify-content: center;
		text-align: center;
		width: 20%;
	}
	td:nth-child(2) {
		width: 100px;
	}
}
.striped-row:nth-child(odd) {
  background-color: #f2f2f2;
}

/* Estilo para filas pares (opcional) */
.striped-row:nth-child(even) {
  background-color: #ffffff;
}

.error-message {
	color: map-get($colors , error);
	font-weight: bold
}
</style>


// WEBPACK FOOTER //
// src/modules/evaluation-360/pages/process-steps-pages/page-configuration-process.vue